<template>
  <div id="data-list-list-view" class="datatable-container">
    <vs-table ref="table" :data="adminRoles">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <vs-button
            class="p-4 shadow-drop mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium"
            color="primary"
            @click="$router.push({ name: 'admin-role-add' })"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            Add New
          </vs-button>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="description">Description</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <div
                class="flex justify-start items-center"
                @click="handleEdit(tr)"
              >
                {{ tr.name }}
              </div>
            </vs-td>

            <vs-td> {{ tr.description }} </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                class="ml-3"
                @click.stop="handleEdit(tr)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-3"
                @click.stop="handleDelete(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <Pagination :total="totalPage" v-model="currentPage" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Pagination from "@/components/Pagination";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      itemsPerPage: 25,
      currentPage: 1,
      pageTotal: 0,
      totalItem: 0,
      totalPage: 0,
    };
  },
  watch: {
    async currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.getAdminRoles({
          page: this.currentPage,
          limit: this.itemsPerPage,
        });
      }
    },
    "deleteAdminRoleState.success"(value) {
      if (value) {
        this.$vs.notify({
          title: "Successful delete!",
          color: "success",
          position: "top-center",
        });
      }
    },
    "deleteAdminRoleState.error"(error) {
      if (error) {
        this.$vs.notify({
          title: "Error!",
          text: error.data.message,
          color: "danger",
          position: "top-center",
        });
      }
    },
  },
  computed: {
    ...mapState({
      adminRoles: ({ adminRoleManagement }) => adminRoleManagement.adminRoles,
      deleteAdminRoleState: ({ adminRoleManagement }) =>
        adminRoleManagement.apiState.deleteAdminRole,
    }),
  },
  methods: {
    ...mapActions({
      getAdminRoles: "adminRoleManagement/getAdminRoles",
      deleteAdminRole: "adminRoleManagement/deleteAdminRole",
    }),
    handleEdit(role) {
      this.$router.push({ name: "admin-role-edit", params: { id: role.id } });
    },
    handleDelete(role) {
      this.$vs.dialog({
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete "${role.name}"`,
        acceptText: "Yes",
        accept: () => {
          this.deleteAdminRole(role.id);
        },
      });
    },
  },
  mounted() {
    this.getAdminRoles({
      page: this.currentPage,
      limit: this.itemsPerPage,
    })
      .then((response) => {
        this.currentPage = parseInt(response.headers["x-pagination-page"]);
        this.pageTotal = parseInt(response.headers["x-pagination-count"]);
        this.totalItem = parseInt(response.headers["x-pagination-total"]);
        this.totalPage = parseInt(response.headers["x-pagination-page-count"]);
      })
      .catch((err) => {
        console.error(err);
      });
  },
};
</script>
